module.exports = __webpack_public_path__ + "media/images/loader-e10e86c6ce221132a0bac638c1f9d2a7.gif";